import type { ReactElement, ReactNode } from 'react';
import { Micro } from '@/components/atoms/micro';
import { cn } from '@/lib/cn';

export type MobileHeaderProps = {
  title: string;
  subtitle?: string;
  leading?: ReactNode;
  trailing?: ReactNode;
  /** When true, show a large block with Micro subtitle + 28-px display title. */
  large?: boolean;
  /** Defaults to var(--bg-page). Pass a transparent class to override. */
  transparent?: boolean;
};

export function MobileHeader({
  title, subtitle, leading, trailing, large = false, transparent = false,
}: MobileHeaderProps): ReactElement {
  return (
    <div className={cn('px-5 pb-3', !transparent && 'bg-[var(--bg-page)]')}>
      <div className="h-11 flex items-center justify-between relative">
        <div className="flex items-center gap-2">
          {leading}
        </div>
        {!large && (
          <div className="font-display text-[15px] font-semibold absolute left-1/2 -translate-x-1/2">
            {title}
          </div>
        )}
        <div className="flex items-center gap-1">
          {trailing}
        </div>
      </div>
      {large && (
        <div className="mt-2">
          {subtitle && <Micro>{subtitle}</Micro>}
          <div className="font-display text-[28px] font-semibold tracking-tight text-[var(--ink)] mt-1 leading-tight">
            {title}
          </div>
        </div>
      )}
    </div>
  );
}
